import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.services';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
	selector: 'app-end-billing-dialog',
	templateUrl: './end-billing-dialog.component.html',
	styleUrls: ['./end-billing-dialog.component.scss'],
	imports: [
		MatProgressSpinner,
		MatDivider,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
	],
})
export class EndBillingDialogComponent {
	errorSettingStatus: boolean = false;
	confirmDisabled: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EndBillingDialogData,
		private readonly dialogRef: MatDialogRef<EndBillingDialogData>,
		private readonly apiService: ApiService
	) {}

	async onConfirmClicked() {
		if (this.confirmDisabled) {
			return;
		}

		this.confirmDisabled = true;
		await this.apiService
			.updateBillingContract(this.data.id, {
				isManuallyEnded: true,
			})
			.then((res) => {
				this.dialogRef.close(true);
			})
			.catch((err) => {
				this.errorSettingStatus = true;
			});
	}

	onCloseClicked(): void {
		this.dialogRef.close(false);
	}
}

export interface EndBillingDialogData {
	id: string;
	companyName: string;
}
